module.exports = __webpack_public_path__ + "static/media/partner-strengths.d9ae3c70.svg";